import {Box, TableCell, TableRow} from "@mui/material";
import {useState} from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import ScheduleIcon from '@mui/icons-material/Schedule';
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import {deleteFeed} from "../services/FeedService";
import {useMessageContext} from "../contexts/MessageContext";
import ScheduleFeedModal from "./ScheduleFeedModal";
import {createOneTimeCalendarEntry} from "../services/CalenderService";

const FeedElement = ({item, setReload}) => {
  const navigate = useNavigate();
  const {notificationHandler} = useMessageContext();
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);

  const obj = {
    NEWS: "News",
    WEEKLY_DIGEST: "Weekly Digest",
    NEWS_GENERAL: "General News",
    NEWS_FINANCE: "Finance News",
    SINGLE_POST: "Single Post",
    ARTICLE: "Article",
    BANNER: "Branding Banner",
  }

  const handleNavigateToFeed = () => {
    navigate(`/app/feed/${item.id}`);
  };

  const deleteMe = (e) => {
    // Prevent event bubbling to avoid navigation when clicking delete
    e.stopPropagation();

    if (window.confirm('Are you sure you want to delete this feed?')) {
      deleteFeed(item.id)
          .then(() => notificationHandler.success('Feed deleted'))
          .then(() => setReload())
          .catch(() => notificationHandler.error('Failed to delete feed'));
    }
  };

  const handleScheduleClick = (e) => {
    // Prevent event bubbling to avoid navigation when clicking schedule
    e.stopPropagation();
    setScheduleModalOpen(true);
  };

  const handleScheduleFeed = async (scheduleData) => {
    try {
      await createOneTimeCalendarEntry(scheduleData);
      notificationHandler.success('Feed scheduled successfully!');
      setReload(); // Refresh the feed list
    } catch (error) {
      console.error('Error scheduling feed:', error);
      throw error; // Re-throw to let the modal handle the error display
    }
  };

  // Determine if feed can be scheduled
  const canSchedule = () => {
    // Only allow scheduling if feed is not already scheduled or posted
    return !['SCHEDULED', 'POSTED'].includes(item.status);
  };

  return (
      <>
        <TableRow
            sx={{"&.MuiTableRow-root" : {
                border: "1px solid #E7E9EE",
                backgroundColor: "#F9FAFB",
                "&:hover" : {
                  backgroundColor: "#dec7f6",
                  cursor: "pointer"
                },
                boxShadow: "0px 0px 1px rgba(12, 26, 75, 0.1), 0px 10px 16px rgba(20, 37, 63, 0.06)",
                "& .MuiTableCell-root": {
                  padding: "8px 6px",
                  fontSize: "0.75rem"
                }
              }}}
            onClick={handleNavigateToFeed}
        >
          <TableCell align={"center"} sx={{ width: "7%" }}>
            {moment(item.createdDate).format("DD/MM/YY HH:mm")}
          </TableCell>
          <TableCell align={"center"} sx={{ width: "8%" }}>
            {item.companyName}
          </TableCell>
          <TableCell align={"center"} sx={{ width: "6%" }}>
            {obj[item.type]}
          </TableCell>
          <TableCell align={"left"} sx={{ width: "14%", whiteSpace: "normal", wordWrap: "break-word" }}>
            {item.title || "-"}
          </TableCell>
          <TableCell align={"left"} sx={{ width: "12%", whiteSpace: "normal", wordWrap: "break-word" }}>
            {item.formatName || "-"}
          </TableCell>
          <TableCell align={"left"} sx={{ width: "12%", whiteSpace: "normal", wordWrap: "break-word" }}>
            {item.subFormatName || "-"}
          </TableCell>
          <TableCell align={"center"} sx={{ width: "6%" }}>
            {item.status}
          </TableCell>
          <TableCell align={"center"} sx={{ width: "5%" }}>
            {item.manual ? "Yes" : "No"}
          </TableCell>
          <TableCell align={"center"} sx={{ width: "8%" }}>
            {item.scheduledDate ? moment.utc(item.scheduledDate).format("DD/MM/YY HH:mm") : "-"}
          </TableCell>
          <TableCell align={"center"} sx={{ width: "8%" }}>
            {item.reviewDate ? moment.utc(item.reviewDate).format("DD/MM/YY HH:mm") : "-"}
          </TableCell>
          <TableCell align={"center"} sx={{ width: "8%" }}>
            {item.postedDate ? moment.utc(item.postedDate).format("DD/MM/YY HH:mm") : "-"}
          </TableCell>
          <TableCell align={"center"}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
              {/* Schedule Button */}
              {canSchedule() && (
                  <Box
                      sx={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "&:hover": {
                          color: "info.main"
                        }
                      }}
                      onClick={handleScheduleClick}
                      title="Schedule for Later"
                  >
                    <ScheduleIcon/>
                  </Box>
              )}

              {/* Delete Button */}
              <Box
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    "&:hover": {
                      color: "error.main"
                    }
                  }}
                  onClick={deleteMe}
                  title="Delete Feed"
              >
                <DeleteIcon/>
              </Box>
            </Box>
          </TableCell>
        </TableRow>

        {/* Schedule Modal */}
        <ScheduleFeedModal
            open={scheduleModalOpen}
            onClose={() => setScheduleModalOpen(false)}
            feedItem={item}
            onSchedule={handleScheduleFeed}
        />
      </>
  )
};

export default FeedElement;
